import * as React from 'react'

/**
 * SyncSimple logo mark — three offset, rounded pill bars (Cyan, Magenta, Amber)
 * stacking down and to the right, each capped with an Ink dot — three async
 * updates aligning (voice in, summary out, team aligned).
 *
 * Vector-traced from the real mark supplied 2026-09-04 (source PNG kept at
 * public/brand/syncsimple-mark-source.png for reference). Geometry: each bar
 * is a 10-tall pill (rx=5); the Ink dot (r=3) sits exactly on one rounded-cap
 * center — left cap for Cyan and Amber, right cap for Magenta.
 */
export function SyncSimpleMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="SyncSimple"
    >
      <rect x="0" y="0" width="47" height="10" rx="5" fill="hsl(var(--signal-cyan))" />
      <circle cx="5" cy="5" r="3" fill="hsl(var(--ink-900))" />

      <rect x="7" y="16" width="47" height="10" rx="5" fill="hsl(var(--signal-magenta))" />
      <circle cx="49" cy="21" r="3" fill="hsl(var(--ink-900))" />

      <rect x="14" y="32" width="48" height="10" rx="5" fill="hsl(var(--signal-amber))" />
      <circle cx="19" cy="37" r="3" fill="hsl(var(--ink-900))" />
    </svg>
  )
}
